import { Mapper } from "../../../../base/utils/mapper";

import { TypeResourceModel }
from "../../../../domain/models/academy/type-resource.model";

import { TypeResourceEntity }
from "../entities/type-resource.entity";

export class TypeResourceImplementationRepositoryMapper
extends Mapper<
TypeResourceEntity,
TypeResourceModel
> {

    mapFrom(param:
    TypeResourceEntity):
    TypeResourceModel {

        return {
            ...param
        };
    }

    mapTo(param:
    TypeResourceModel):
    TypeResourceEntity {

        return {
            ...param
        };
    }
}